function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "./Text";
import { TextInput } from "./TextInput";
import { View } from "./View";
import { useTheme } from "../styles";
/**
 * A field input that allows the user to input free form text up to a specified
 * length.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-91}
 */ export function MaxLengthTextInput(_param) {
    var containerStyle = _param.containerStyle, props = _object_without_properties(_param, [
        "containerStyle"
    ]);
    var _props_value;
    var theme = useTheme().theme;
    var _props_value_length;
    return /*#__PURE__*/ _jsxs(View, {
        style: containerStyle,
        children: [
            /*#__PURE__*/ _jsx(TextInput, _object_spread({}, props)),
            /*#__PURE__*/ _jsxs(View, {
                row: true,
                style: {
                    justifyContent: 'space-between',
                    marginHorizontal: 20
                },
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        size: 13,
                        text: "".concat(props.maxLength - ((_props_value_length = (_props_value = props.value) === null || _props_value === void 0 ? void 0 : _props_value.length) !== null && _props_value_length !== void 0 ? _props_value_length : 0), " characters left"),
                        style: {
                            color: theme.color.gray400
                        }
                    }),
                    props.bottomContent
                ]
            })
        ]
    });
}
